import moment from "moment-timezone";

const MONDAY = 1;

// The first day of the Planner week holding `value`, at midnight. `weekStartsOn` is 0 (Sunday) to
// 6, the person's "Start week on". A zoned moment keeps its zone.
export const startOfPlannerWeek = (value, weekStartsOn = MONDAY) => {
  const day = moment.isMoment(value) ? value.clone() : moment(value);
  const daysIntoWeek = (day.day() - weekStartsOn + 7) % 7;

  return day.subtract(daysIntoWeek, "days").startOf("day");
};

export const endOfPlannerWeek = (value, weekStartsOn = MONDAY) =>
  startOfPlannerWeek(value, weekStartsOn).add(6, "days").endOf("day");
